export default function Logo({ fill, height }: { fill?: string, height?: string}) {
	return (
			<svg style={{ height }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 400.502 761.355">
				<path fill={fill} d="M0,7.8813c0,0,146.5889-30.1104,215.2314,27.3745C298.9688,105.3813,352.2656,207.957,379.5,468.8813
	c21.6582,207.5,21,257.5,21,257.5s-5.3643,5.2061-14,5.5c-12.1064,0.4121-15.4053-3.0283-15.4053-3.0283L329,560.3813l-25.5-1
	c0,0,17.1426,77.165,23.5293,100.7881c0,0-38.2227-2.416-51.8145,18.0869c-13.8135,20.8379-18.7344,39.0361-43.4648,57.625
	c-23.2813,17.5-68.25,25.4736-88.25,25.4736c0,0-5.4331-68.5918-9.5-111.9736c-3.9551-42.1904-14.5-113.5-14.5-113.5
	s39.4048,4.0801,68.1509-18.6396c34.2007-27.0303,30.8491-55.3604,30.8491-55.3604s-34.5918,4.7832-67.8115,15.9287
	C116.9614,489.1255,94,500.8813,94,500.8813s-0.7764,23.0615,1.6523,35.6982C99.2334,555.2124,113,596.8813,113,596.8813
	s-12.8667,6.541-23.3564,8.6348c-8.0874,1.6143-20.0703,1.8271-28.6436-0.6348c1.0557-31.1377-1.5-50.5-1.5-50.5l-6.5,58h20
	c0,0,4.5,56.5,6.5,75l9.3335,73.334c0,0-20.3335,4.666-27.3335-26.667S33.269,554.8198,27.9355,486.4868
	c0,0,4.4814,27.4434,10.3081,34.041c7.2412,8.1992,17.9233,6.8545,17.9233,6.8545s-0.0005-10.666-11.667-24s-40-20.334-40-20.334
	s-11-116.9995,10.3335-158.6665c18.6323-36.3916,43-57.3335,61-66L46.5,223.0488h61.667c0,0,8.667-8.667,18-12.667s24.3335-9,29-10
	l-83.3335,7.667L0,7.8813z"/>
			</svg>
	)
}
